module.exports = __webpack_public_path__ + "static/img/title-button-selected4.73cdccff.png";